import { render, staticRenderFns } from "./KPanelProperty.vue?vue&type=template&id=33e7c376&"
import script from "./KPanelProperty.vue?vue&type=script&lang=js&"
export * from "./KPanelProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports